import {
  LoadCategoryFailure,
  LoadCategorySuccess,
  CategoryActionsUnion,
  CategoryActionTypes
} from './category.actions';

import { categoryInitialState } from './category.state';


export function categoryReducer(state = categoryInitialState, action: CategoryActionsUnion) {
  switch (action.type) {
    case CategoryActionTypes.LOAD_CATEGORY:
      return { ...state, loading: true };
    case CategoryActionTypes.LOAD_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        payload: (action as LoadCategorySuccess).payload
      };
    case CategoryActionTypes.LOAD_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: (action as LoadCategoryFailure).payload.error
      };
    case CategoryActionTypes.CLEAR_CATEGORY:
      return { ...categoryInitialState };
    default:
      return { ...state };
  }
}
